module.exports = __webpack_public_path__ + "8fc09eac24a47576c725a0c975457ed9.webp";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/LynksExport/assets/Sec-2/icon_5.webp
// module id = ./app/containers/StaticPage/LynksExport/assets/Sec-2/icon_5.webp
// module chunks = 40